<template>
    <v-btn
    class="IconTextButton-outline"
    outlined
    small
    elevation="0"
    :disabled="isDisabled"
    @click="buttonClick"
    >
        <v-icon small class="mr-1">{{ icon }}</v-icon>
        {{ buttonText }}
    </v-btn>
</template>

<script>
export default {
	name: 'IconTextButtonoutline',
    props: {
        icon: {
        type: String,
        default: 'mdi-pencil'
        },
        buttonText: {
        type: String,
        default: 'Edit'
        },
        buttonClass: {
        type: String,
        default: 'IconTextButtonoutline'
        },
        buttonClick: {
        type: Function
        },
        isDisabled: {
            type: Boolean
        }
    },
    methods: {

    }
};
</script>

<style scoped>

</style>
